import apiClient, { ApiResponse } from '../api-client'

export interface UpdatePickupOrderSettings {
  serviceDisabled: boolean
  maxPending: number
  enabledUserEmails: string[]
}
export interface PickupOrderSettings {
  serviceDisabled: boolean
  maxPending: number
  /** For admin: list of enabled emails. Omitted for regular users. */
  enabledUserEmails?: string[]
  /** For regular users: whether they are allowed. Omitted for admin. */
  allowed?: boolean
  isAtCapacity: boolean
  currentPendingCount?: number
}

export interface AppConfig {
  isMaintenance: boolean
}

export const getAppConfig = async () => {
  const { data } = await apiClient.get<ApiResponse<AppConfig>>('/app-config')
  return data.data
}

export const getPickupOrderSettings = async (): Promise<PickupOrderSettings> => {
  const { data } = await apiClient.get<ApiResponse<PickupOrderSettings>>('/pickup-order-settings')
  return data.data
}

export const updatePickupOrderSettings = async (settings: UpdatePickupOrderSettings): Promise<void> => {
  await apiClient.put<ApiResponse<unknown>>('/pickup-order-settings', settings)
}
